import { useCallback, useEffect, useState } from "react";

interface ReturnType {
  isMobile: boolean;
  innerWidth: number;
  outerWidth: number;
}

export const useWidth = (): ReturnType => {
  const [state, setState] = useState<ReturnType>({
    innerWidth: 0,
    outerWidth: 0,
    isMobile: false,
  });

  const calc = useCallback(() => {
    setState({
      innerWidth: window.innerWidth,
      outerWidth: window.outerWidth,
      isMobile: window.outerWidth < 992,
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", calc);
    calc();

    return () => {
      window.removeEventListener("resize", calc);
    };
  }, [calc]);

  return state;
};
